import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";

import moment from "moment";

export const stringLPad = (num, size) => {
  let result = num;
  while (result.length < size) result = `0${result}`;
  return result;
};

export const buildCustomerName = (customer) => {
  if (customer.lastName) {
    return `${customer.name} ${customer.lastName}`;
  }
  return customer.name;
};

export const dbValueToFloat = (value) => {
  if (!value || value === "0E-6176" || isNaN(value)) return 0;
  if (!value || value === "0E-6176" || isNaN(value)) return 0;
  try {
    return parseFloat(value);
  } catch (err) {
    return 0;
  }
};

export const printDocumentPDF = async (component, fileName) => {
  const pdfDocument = await pdf(component).toBlob();
  saveAs(pdfDocument, fileName);
};

/**
 * creates a copy and remove extra data
 * @param objectToUpdate
 * @returns {*}
 */
export const getUpdateObject = (objectToUpdate) => {
  const result = {
    ...objectToUpdate,
  };
  delete result.__typename;
  return result;
};

export function getClockSessionDurationForUpdate(sessionStart, sessionEnd) {
  return (
    "" +
    parseInt(
      (moment(sessionEnd).toDate().getTime() -
        moment(sessionStart).toDate().getTime()) /
        1000
    )
  );
}
